import {Component, input, InputSignal, OnDestroy, OnInit} from '@angular/core';
import {SectionsContainer} from "../../core/definitions/sections-container";
import {SectionViewCopy} from "../section-view-copy/section-view-copy";

@Component({
  selector: 'app-object-copy',
  imports: [
    SectionViewCopy
  ],
  templateUrl: './object-copy.html',
  styleUrl: './object-copy.scss'
})
export class ObjectCopy implements OnDestroy, OnInit {
  sectionsContainer: InputSignal<SectionsContainer> = input();
  sourceArtifactId: InputSignal<string> = input();

  ngOnDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  ngOnInit() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleBeforeUnload = (event: BeforeUnloadEvent) => {
    event.preventDefault();

    return 'This value does not matter. Only here to trigger the confirmation dialog.';
  }
}
